import React, { useCallback, useContext } from 'react'
import { useSelector } from 'react-redux'
import { WrapHeaderStyles, WrapPullDown, WrapContent } from './Style'
import { fieldsTyps } from 'components/Form'
import { BackAndNextApp, headerHooks } from '.'
import { AdvancedBtn } from 'components/FilterManager'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { Divider } from '@mui/material'
import { Can } from 'components/Permissions'
import { AbilityContext } from 'components/Permissions/Can'

const Header = (props) => {
    const { hide: hideHeader } = props

    const dispatch = useDispatch()
    const ability = useContext(AbilityContext)

    const { headerFilters, isExpanded } = useSelector(state => state.header)

    const pulldownsData = headerHooks.usePulldowns()
    const advancedFilters = headerHooks.useAdvancedFilters()
    const headerHeight = headerHooks.useHeaderHeight()

    const isSuperUser = ability.can("manage", "super-user")
    const isTesterUser = ability.can("manage", "tester")

    const showAdvancedFilters = isSuperUser || isTesterUser

    const handleChangePulldown = async (key, value) => {
        const nHeaderFilters = { ...headerFilters, [key]: value }
        dispatch(actions.setHeaderFilters(nHeaderFilters))
        dispatch(actions.setTestTaker({}))
    }

    const setIsExpanded = useCallback(() => {
        dispatch(actions.setIsExpanded(!isExpanded))
    }, [isExpanded])

    return (
        <WrapHeaderStyles headerHeight={headerHeight}>
            <div className='header-pulldowns'>
                <WrapContent hidden={hideHeader}>
                    <BackAndNextApp />
                    <div className='filters'>
                        {pulldownsData.map((pulldown, index) => {
                            const { name, hide } = pulldown
                            const input = {
                                value: headerFilters?.[name],
                                onChange: (value) => handleChangePulldown(name, value)
                            }
                            const Component = fieldsTyps[pulldown.component]
                            return (
                                hide ||
                                <WrapPullDown key={index}>
                                    <Component
                                        input={input}
                                        {...pulldown}
                                    />
                                </WrapPullDown>
                            )
                        })}
                    </div>
                    {hideHeader ||
                        (
                            showAdvancedFilters &&
                            <div className='advanced-btn'>
                                <AdvancedBtn
                                    height={41.5}
                                    size="large"
                                    removeAdvancedFilters={() => { }}
                                    advancedFiltersCount={0}
                                    isExpanded={isExpanded}
                                    setIsExpanded={setIsExpanded}
                                />
                            </div>
                        )
                    }

                </WrapContent>
                {
                    isExpanded &&
                    <React.Fragment>
                        <Divider sx={{ borderColor: "#E8EEF6", width: "100%" }} />
                        <WrapContent>
                            <div className='filters'>
                                {advancedFilters.map((pulldown, index) => {
                                    const { name, hide } = pulldown
                                    const input = {
                                        value: headerFilters?.[name],
                                        onChange: (value) => handleChangePulldown(name, value)
                                    }
                                    const Component = fieldsTyps[pulldown.component]
                                    return (
                                        hide ||
                                        <WrapPullDown key={index}>
                                            <Component input={input} {...pulldown} />
                                        </WrapPullDown>
                                    )
                                })}
                            </div>
                        </WrapContent>
                    </React.Fragment>
                }
            </div>
        </WrapHeaderStyles>
    )
}

export default Header